import laravelAxiosClient from "../laravelAxiosClient";
import {
  AchatsResult,
  CreateFactureProduitPayload,
  CreateFactureProduitResult,
  ProduitsResult,
} from "../interfaces/produits.interface";

export const findAllProduits = async () => {
  const { data } = await laravelAxiosClient.get<ProduitsResult>("/produits");
  return data;
};

export const findAllAchats = async () => {
  const { data } = await laravelAxiosClient.get<AchatsResult>("/produits/achats");
  return data;
};

export const createFactureProduit = async (payload: CreateFactureProduitPayload) => {
  const { data } = await laravelAxiosClient.post<CreateFactureProduitResult>("/produits/facture", payload);
  return data;
};
